// SECTIONS

import {
    constables
} from './base.js';

const breakpoint = constables().breakpoint;

const times = constables().times;
const timem = constables().timem;
const timel = constables().timel;

// INIT

export function initvorschau() {

    routes();

}

function routes() {

    let vorschau = document.querySelectorAll('section.vorschau')
    if (vorschau.length !== 0) {
        initVorschau(vorschau);
    }

}

function initVorschau(vorschau) {

    vorschau.forEach(v => {

        v.addEventListener('click', () => {

            if (!v.classList.contains('aktiv')) {
                removeVorschau();
            }
            v.classList.toggle('aktiv');

        })

    })

}

function removeVorschau() {

    let aktiv = document.querySelectorAll('section.vorschau.aktiv');
    aktiv.forEach(a => {

        a.classList.remove('aktiv');

    })

}

function toggleVorschau() {

}